import { HttpHeaders } from '@angular/common/http';

const PROTOCOL = "https"; //const PROTOCOL = "https";
//const PORT = 44301;//const PORT = 443;
// const BASE_URL = "iisrestfacturascore.azurewebsites.net"; //const BASE_URL = "iisrestfacturascore.azurewebsites.net";
const BASE_URL = "yachay-software.com"; //const BASE_URL = "iisrestfacturascore.azurewebsites.net";

export class ConfigurationComprobanteDataSource {
  public baseUrl: string;
  public user_id: string;
  public user_token: string;
  public pws_token: string;
  public user_name: string;
  public nroItemsCarrito: number;
  public categoriasEnFamilias: boolean = false;
  public imagenLogo: string = "";

  private static instance: ConfigurationComprobanteDataSource;

  private constructor() {
    this.baseUrl = `${PROTOCOL}://${BASE_URL}/`;
  }

  public static getInstance(): ConfigurationComprobanteDataSource {
    if (!ConfigurationComprobanteDataSource.instance) {
      ConfigurationComprobanteDataSource.instance = new ConfigurationComprobanteDataSource();
    }
    return ConfigurationComprobanteDataSource.instance;
  }

  getConfHeaders(): HttpHeaders {
    var headers = new HttpHeaders();
    headers = headers.set('Authorization', `Basic ZjRiMWFjOTYtY2I2MC00ODY0LTk0NTgtY2RiMDZjNWE2ODcy:NjhmM2Y3MzMtZTc4ZC00MWZkLThmZDEtNWU3NGUzMzM4MjQw`);
    //headers = headers.set('Content-Type', `text/plain`);
    return headers;
  }
}
